const columns = [
  {
    field: 'code',
    label: 'Rodzaj dokumentu',
    sort: 'asc',
    type: "enum",
    enumType: "enums/legalDocumentCode",
    width: 150,
  },
  {
    field: 'title',
    label: 'Nazwa wersji',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'version',
    label: 'Wersja',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'creationDate',
    label: 'Data utworzenia',
    sort: 'asc',
    width: 150,
  },
  {
    field: 'file',
    label: 'Plik',
    sort: 'asc',
    width: 150,
    type: "file"
  },
];

export default columns;
